module.exports = __webpack_public_path__ + "static/img/t6.1ca14dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/t6.png
// module id = KG/O
// module chunks = 1